export  const validationService = {
    validateUserLogin(data){
        const errors = {}
        if(!data.emailOrMobile?.trim()){
            // errors.emailOrMobile = "Enter mobile or email Id"
            errors.emailOrMobile = "Invalid username or password"
        }

        if(!data.password?.trim()){
            errors.password = "Invalid username or password"
        }
        return errors
    }
}